import React from "react";

import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  SelectControl,
  FormSubmitButton,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "../../utils/hoc/withRouter";
import { ClearButton, ComponentHeader, CustomModal, ImageUploader, SelectKeywords, Spinner } from "../common";
import { getCommonApi, getKeywordNameApi } from "./Api";
import { postAuthCommonApi, putAuthCommonApi } from "../content/Api";
import { toast } from "react-toastify";
import { getAdminUser, getSafeArray, isPartnerAllowed } from "../../utils/ReusableFunctions";
import { getAllSsoPartnersApi } from "../sso/Api";
import { isModuleExist, MODULE_ID_MAP, publishOptions } from "../../utils/Constant";

class TargetedContentForm extends BaseReactComponent {
  constructor(props) {
    super(props);

    const data = props.editData || props?.location?.state?.data || null;
    const AccesData = isModuleExist(MODULE_ID_MAP.ContentMasterTargetedContentList);


    let partners = this.loadDefaultPartners(AccesData)
    if (data?.partners?.list) {
      partners = data?.partners
    }

    this.state = {
      AccessData: AccesData,
      editData: data || "",
      allDropDownData: '',
      targetedContentName: data?.targetedContentName || "",
      description: data?.description || "",
      thumbnailPath: "",
      thumbnailFile: null,
      bannerPath: "",
      bannerfile: null,
      circleImagePath: "",
      circleImageFile: null,
      uploadImage: data?.thumbnailPath || null,
      uploadImage2: data?.bannerPath || null,
      uploadImage3: data?.circleImagePath || null,

      attachments: [],
      // *
      ageGroup: data?.ageGroup || "",
      gender: data?.gender || "",
      employmentType: data?.employmentType || '',
      incomeGroup: data?.incomeGroup || '',
      maritalStatus: data?.maritalStatus || '',
      goal: data?.goal || '',
      riskAppetite: data?.riskAppetite || '',
      financialUnderstanding: data?.financialUnderstanding || '',


      resLoading: false,
      partners,
      keywords: data?.keywords ? data.keywords.split(",").map(item => item.trim()).filter(Boolean) : [],
      keywordOption: [],
      search: "",
      isAddContent: true,
    };
  }
  convertToCamelCase = sentence => sentence.toLowerCase().split(' ').map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))).join('');
  async componentDidMount() {
    const res = await getCommonApi('targetedContentFilters')

    this.setState({
      allDropDownData: res.data.data.list
    })
    getAllSsoPartnersApi(this);
    this.props.getKeywordNameApi(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) {
      this.props.getKeywordNameApi(this);
    }
  }
  keywordsChangeHandler = (info) => {
    this.setState({ search: info })
  }
  imageUploaser = (e, name) => {

    const imageUrl = URL.createObjectURL(e.target.files[0]);
    if (name === "banner") {
      this.setState({ bannerPath: e.target.files[0].name, bannerfile: e.target.files[0], uploadImage2: imageUrl })
    } else if (name === "circleImage") {
      this.setState({ circleImagePath: e.target.files[0].name, circleImageFile: e.target.files[0], uploadImage3: imageUrl })
    } else {
      this.setState({ thumbnailPath: e.target.files[0].name, thumbnailFile: e.target.files[0], uploadImage: imageUrl })
    }
  }

  onValidSubmit = async () => {
    this.setState({ resLoading: true })
    const { thumbnailPath, bannerPath, editData, circleImagePath, bannerfile, thumbnailFile, circleImageFile } = this.state;

    if (!this.state.targetedContentName) {
      toast.error("Fields can not be empty.");
      this.setState({ resLoading: false });
    } else {
      let eventData = {
        "data": {
          "targetedContentName": this.state.targetedContentName,
          "description": this.state.description,
          ...(thumbnailPath ? { "thumbnailPath": thumbnailPath } : {}),
          ...(bannerPath ? { "bannerPath": bannerPath } : {}),
          "keywords": this.state.keywords?.length > 0 ? this.state.keywords.join(",") : "",
          'partners': this.state.partners,
        }
      };
      if(!isPartnerAllowed(this.state.AccessData?.id)){
      delete eventData.data.partners;
    }

      const data = new FormData();
      data.append("key", JSON.stringify(eventData));
      thumbnailFile !== null && data.append("file", thumbnailFile);
      bannerfile !== null && data.append("file", bannerfile);

      if (this.state.editData) {
        const response = await putAuthCommonApi(`targetedContent/${this.state.editData?.uuid}`, data);
        if (response.status === 200) {
          this.setState({ resLoading: false });
          // Refresh parent list and close modal
          const ctx = this.props.this || this.props.ctx;
          if (ctx) {
            ctx.props.getTargetedContentApi(ctx);
          }
          this.props.onHide();
        } else {
          this.setState({ resLoading: false })
        }
      } else {
        const response = await postAuthCommonApi('/targetedContent', data);
        if (response.status === 200) {
          this.setState({ resLoading: false });
          // Refresh parent list and close modal
          const ctx = this.props.this || this.props.ctx;
          if (ctx) {
            ctx.props.getTargetedContentApi(ctx);
          }
          this.props.onHide();
        } else {
          this.setState({ resLoading: false })
        }

      }
    }

  };

  render() {
    const { uploadImage, thumbnailFile, resLoading, bannerfile, uploadImage2, circleImageFile, uploadImage3, allDropDownData, ageGroup, gender, employmentType, incomeGroup, maritalStatus, goal, riskAppetite, financialUnderstanding } = this.state;
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.state.editData ? "Edit Targeted Content" : "Add Targeted Content"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          {/* Row 1: Partners | Name */}
          <Row>
            {isPartnerAllowed(this.state.AccessData?.id) && <Col md={6}>
              <FormElement
                valueLink={this.linkState(this, "partners.list")}
                label="Publish To Partner(s)"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Publish To cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    options: this.state?.ssoPartnersOptions || [],
                    placeholder: "Select Partner(s)",
                    multiple: true,
                    searchable: true,
                    selectAll: true,
                    onChangeCallback: (onBlur) => {
                    },
                  },
                }}
              />
            </Col>}
            <Col md={6}>
              <FormElement
                valueLink={this.linkState(this, "targetedContentName")}
                label="Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    placeholder: "Enter Name",
                  },
                }}
              />
            </Col>
          </Row>
          {/* Row 2: Thumbnail | Banner */}
          <Row>
            <Col md={6}>
              <ImageUploader required={false} id="Thumbnail" label="Upload Thumbnail" name={typeof (thumbnailFile) == 'object' ? uploadImage : thumbnailFile} onChange={(e) => this.imageUploaser(e, "thumbnail")} onDelete={() => this.setState({ thumbnailFile: "" })} />
            </Col>
            <Col md={6}>
              <ImageUploader required={false} id="Banner" label="Upload Banner" name={typeof (bannerfile) == 'object' ? uploadImage2 : bannerfile} onChange={(e) => this.imageUploaser(e, "banner")} onDelete={() => this.setState({ bannerfile: "" })} />
            </Col>
          </Row>
          {/* Row 3: Description | Keywords */}
          <Row>
            <Col md={6}>
              <FormElement
                valueLink={this.linkState(this, "description")}
                label="Description"
                helpText="Description can't be more than 4000 character"
                control={{
                  type: CustomTextControl,
                  settings: {
                    as: "textarea",
                    placeholder: "Enter Description",
                  },
                }}
              />
            </Col>
            <Col md={6}>
              <SelectKeywords
                required={false}
                label="Keywords"
                placeholder={'Enter Keywords'}
                onchangeHandler={(data) => this.keywordsChangeHandler(data)}
                selectedKeyWords={this.state.keywords}
                options={this.state.keywordOption}
                getKeys={(data) => this.setState({ keywords: data })}
              />
            </Col>
          </Row>
          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              {resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Saving...</span> : "Save"}
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

export default connect(null, { getKeywordNameApi })(withRouter(TargetedContentForm));
